<template>
  <div>
    <b-modal
      id="form-role-modal"
      size="lg"
      no-close-on-backdrop
      :title="(editId == null ? 'Tambah' : 'Edit') + ' ' + pageTitle"
    >
      <validation-observer ref="roleValidation">
        <form>
          <horizontal-form-group label="Nama Role">
            <validation-provider
              #default="{ errors }"
              name="roleName"
              rules="required"
            >
              <InputText
                :value="formPayload.roleName"
                @value="formPayload.roleName = $event"
                :errors="errors"
              />
            </validation-provider>
          </horizontal-form-group>

          <horizontal-form-group label="Kode Role">
            <validation-provider
              #default="{ errors }"
              name="roleCode"
              rules="required"
            >
              <InputText
                :value="formPayload.roleCode"
                @value="formPayload.roleCode = $event"
                :errors="errors"
              />
            </validation-provider>
          </horizontal-form-group>
          <horizontal-form-group label="Jenis User">
            <validation-provider
              #default="{ errors }"
              name="typeUser"
              rules="required"
            >
            <InputSelect :value="formPayloadRole.typeUser" @value="formPayloadRole.typeUser = $event" :options="optionsTypeUser" :errors="errors" />
            </validation-provider>
          </horizontal-form-group>
          <hr />
          <!-- {{ formPayload.selectedUicomponents }} -->
          <div class="title-group" v-if="isMobile">
            <h4 style="font-size: 15px;">Mobile</h4>
          </div>
          <div v-for="(item, index) in menusMobile" :key="index">
            <b-form-checkbox v-model="item.isSelected" @change="onChange(item.componentCode)" /> {{ item.uiName }}
            <div v-if="item.childEl.length > 0" style="margin-left: 20px;">
              <div v-for="(childItem, Subindex) in item.childEl" :key="Subindex">
                <b-form-checkbox v-model="childItem.isSelected" @change="onChange(childItem.componentCode)" /> {{ childItem.uiName }} -> {{ childItem.page }}
              </div>
            </div>
          </div>
          <div class="title-group" v-if="isPortal">
            <br />
            <h4 style="font-size: 15px;">Portal</h4>
          </div>
          <div v-for="(item, index) in menusPortal" :key="index+'portal'">
            <b-form-checkbox v-model="item.isSelected" @change="onChange(item.componentCode)" /> {{ item.uiName }}
            <div v-if="item.childEl.length > 0" style="margin-left: 20px;">
              <div v-for="(childItem, Subindex) in item.childEl" :key="Subindex">
                <b-form-checkbox v-model="childItem.isSelected" @change="onChange(childItem.componentCode)" /> {{ childItem.uiName }} -> {{ childItem.page }}
              </div>
            </div>
          </div>
          <div class="title-group" v-if="isAdmin">
            <h4 style="font-size: 15px;">Admin</h4>
          </div>
          <div v-for="(item, index) in menusAdmin" :key="index+'admin'">
            <b-form-checkbox v-model="item.isSelected" @change="onChange(item.componentCode)" /> {{ item.uiName }}
            <div v-if="item.childEl.length > 0" style="margin-left: 20px;">
              <div v-for="(childItem, Subindex) in item.childEl" :key="Subindex">
                <b-form-checkbox v-model="childItem.isSelected" @change="onChange(childItem.componentCode)" /> {{ childItem.uiName }} -> {{ childItem.page }}
              </div>
            </div>
          </div>

        </form>
      </validation-observer>

      <template #modal-footer="{}">
        <b-button
          class="d-flex"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          :disabled="isLoadingRole"
          @click="submitItem()"
        >
          <b-spinner small variant="light" class="mr-1" v-if="isLoadingRole" />
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import { BButton, BSpinner, BFormFile, BFormCheckbox } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

import InputText from "@/components/InputText.vue";
import InputTextArea from "@/components/InputTextArea.vue";
import InputFile from "@/components/InputFile.vue";

import { UicomponentService } from "@/services/uicomponent.service";
import InputSelect from '../InputSelect'


export default {
  components: {
    InputSelect,
    required,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    InputText,
    InputTextArea,
    InputFile,
    BFormFile,
    BFormCheckbox,
},

  directives: {
    Ripple,
  },

  props: {
    pageTitle: {
      type: String,
    },
    editId: {
      type: "",
    },
    loading: {
      type: Boolean,
    },
    formPayload: {
      type: Object,
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
  },

  data() {
    return {
      isLoadingRole: false,
      formPayloadRole: {
        roleName: "",
        roleCode: "",
        roleId: "",
        typeUser: "non-admin",
        selectedUicomponents: []
      },
      isMobile: false,
      isPortal: false,
      isAdmin: false,
      menusMobile: [],
      menusPortal: [],
      menusAdmin: [],
      testing: [],
      optionsTypeUser: [
        {
          value: 'non-admin',
          text: 'Non Admin'
        },
        {
          value: 'admin',
          text: 'Admin'
        }
      ]
    };
  },

  watch: {
    loading(value) {
      this.isLoadingRole = value;
    },
    'formPayloadRole.typeUser': {
      async handler(value) {
        if (value == 'non-admin') {
          this.formPayload.isAdmin = false;
        }
        if (value == 'admin') {
          this.formPayload.isAdmin = true;
        }
        this.formPayloadRole.selectedUicomponents = [];
        this.formPayload.selectedUicomponents = [];
        this.testing = [];
        await this.fetchUicomponentData(value);
        if (!this.formPayload.isAdd) {
          this.selectedFilter(this.formPayload);
        }
      }
    },
    formPayload: {
       async handler(value) {
         if (!value.isAdmin) {
           this.formPayloadRole.typeUser = 'non-admin';
         }
         if (value.isAdmin) {
           this.formPayloadRole.typeUser = 'admin';
         }
         if (!value.isAdd) {
           this.selectedFilter(value);
         }
        // this.formPayloadRole = value;
        //
        // this.formPayloadRole.selectedUicomponents = []
        //
        // for (let i = 0; i < value.uiComponents.length; i++) {
        //     this.formPayloadRole.selectedUicomponents.push(value.uiComponents[i]['componentCode']);
        // }
        // if (this.editId == null) {
        // }
      },
      deep: true,
    },
    formPayloadRole: {
      handler(value) {
        this.$emit("formPayloadRole", value);
      },
      deep: true,
    },
  },

  methods: {
    submitItem() {
      this.$refs.roleValidation.validate().then((success) => {
        if (success) {
          if (this.editId == null) {
            this.createItem();
          } else {
            this.updateItem();
          }
        }
      });
    },
    selectedFilter(value) {
      if (!value.isAdd) {
        if (value.isAdmin) {
          for (let i = 0; i < value.uiComponents.length; i++) {
            for (let j = 0; j < this.menusAdmin.length; j++) {
              if (value.uiComponents[i].componentCode === this.menusAdmin[j].componentCode) {
                this.menusAdmin[j].isSelected = true;
              }
              for (let k = 0; k < this.menusAdmin[j].childEl.length; k++) {
                if (value.uiComponents[i].componentCode === this.menusAdmin[j].childEl[k].componentCode) {
                  this.menusAdmin[j].childEl[k].isSelected = true;
                }
              }
            }
          }
        }
        if (!value.isAdmin) {
          for (let i = 0; i < value.uiComponents.length; i++) {
            for (let j = 0; j < this.menusMobile.length; j++) {
              if (value.uiComponents[i].componentCode === this.menusMobile[j].componentCode) {
                this.menusMobile[j].isSelected = true;
              }
              for (let k = 0; k < this.menusMobile[j].childEl.length; k++) {
                if (value.uiComponents[i].componentCode === this.menusMobile[j].childEl[k].componentCode) {
                  this.menusMobile[j].childEl[k].isSelected = true;
                }
              }
            }
            for (let j = 0; j < this.menusPortal.length; j++) {
              if (value.uiComponents[i].componentCode === this.menusPortal[j].componentCode) {
                this.menusPortal[j].isSelected = true;
              }
              for (let k = 0; k < this.menusPortal[j].childEl.length; k++) {
                if (value.uiComponents[i].componentCode === this.menusPortal[j].childEl[k].componentCode) {
                  this.menusPortal[j].childEl[k].isSelected = true;
                }
              }
            }
          }
        }
        this.onChange();
      }
    },
    async fetchUicomponentData(params) {
      try {
        const { data } = await UicomponentService.findAll({},params);
        this.items = data.content;
        // this.pagination.total = data.total;
        let result = this.items;
        result = result.sort(this.dynamicSort("sortOrder"));
        this.menusMobile = [];
        this.menusPortal = [];
        this.menusAdmin = [];
        this.isMobile = false;
        this.isPortal = false;
        this.isAdmin = false;
        for (let i = 0; i < result.length; i++) {
            // this.menus.push(result[i]);
            if (result[i].userType == 'mb') {
              result[i].isSelected = false;
              for (let j = 0; j < result[i].childEl.length; j++) {
                result[i].childEl[j].isSelected = false;
              }
              this.menusMobile.push(result[i]);
              this.isMobile = true;
            }
            if (result[i].userType == 'portal') {
              result[i].isSelected = false;
              for (let j = 0; j < result[i].childEl.length; j++) {
                result[i].childEl[j].isSelected = false;
              }
              this.menusPortal.push(result[i]);
              this.isPortal = true;
            }
            if (result[i].userType == 'admin') {
              result[i].isSelected = false;
              for (let j = 0; j < result[i].childEl.length; j++) {
                result[i].childEl[j].isSelected = false;
              }
              this.menusAdmin.push(result[i]);
              this.isAdmin = true;
            }
            // if (result[i].userType == 'admin') {
            //     // this.menus.push({
            //     //     title: result[i].uiTitle,
            //     //     route: result[i].page,
            //     // });
            //
            //     this.menus.push(result[i]);
            //
            //     // if (result[i].childEl.length > 0) {
            //     //     this.menus[i].children = result[i].childEl;
            //
            //     //     for (let j = 0; j < result[i].childEl.length; j++) {
            //     //     result[i].childEl[j].title = result[i].childEl[j].uiTitle;
            //     //     result[i].childEl[j].route = result[i].childEl[j].page;
            //     //     }
            //     // }
            // }

        }
        // window.console.log(this.menusAdmin);
      } catch (e) {
        console.log(e)
      } finally {
        // this.loading = false;
      }
    },
    dynamicSort(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a, b) {
        var result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    onChange() {
      // if (this.testing.includes(value)) {
      //   this.testing.splice(this.testing.indexOf(value))
      // } else {
      //   this.testing.push(value);
      // }
      //
      // this.formPayload.selectedUicomponents = this.testing
      // console.log(this.menusMobile);
      this.testing = [];
      if (this.formPayloadRole.typeUser == 'non-admin') {
        // find mobile
        let find = this.menusMobile.filter((items) => {
          return true === items.isSelected;
        });
        if (find.length >= 1) {
          this.testing.push(...find);
        }
        this.menusMobile.forEach((data) => {
          let findSub = data.childEl.filter((items) => {
            return true === items.isSelected;
          });
          if (findSub.length >= 1) {
            this.testing.push(...findSub);
          }
        });

        // // find portal
        let findPortal = this.menusPortal.filter((items) => {
          return true === items.isSelected;
        });
        if (findPortal.length >= 1) {
          this.testing.push(...findPortal);
        }
        this.menusPortal.forEach((data) => {
          let findSubPortal = data.childEl.filter((items) => {
            return true === items.isSelected;
          });
          if (findSubPortal.length >= 1) {
            this.testing.push(...findSubPortal);
          }
        });
        this.formPayload.selectedUicomponents = this.testing;
        window.console.log(this.formPayload);
      }
      if (this.formPayloadRole.typeUser == 'admin') {
        // find admin
        let find = this.menusAdmin.filter((items) => {
          return true === items.isSelected;
        });
        if (find.length >= 1) {
          this.testing.push(...find);
        }
        this.menusAdmin.forEach((data) => {
          let findSub = data.childEl.filter((items) => {
            return true === items.isSelected;
          });
          if (findSub.length >= 1) {
            this.testing.push(...findSub);
          }
        });
        this.formPayload.selectedUicomponents = this.testing;
        // window.console.log(this.testing);
        window.console.log(this.formPayload);
      }
      // window.console.log(this.formPayloadRole.typeUser);
    }
  },

  mounted() {
      this.fetchUicomponentData();
  },
};
</script>

<style scoped>

    .custom-checkbox {
        display: inline-block !important;
        margin-bottom: 8px !important;
    }

</style>
